<div class="team-card" [ngStyle]="{
  backgroundImage: (tournamentTeam.division.cover.path || tournament.previewImage.path) ?
    'url(' + (tournamentTeam.division.cover.path || tournament.previewImage.path) + ')'
    : ''
}" [ngClass]="{'with-image': (tournamentTeam.division.cover.path || tournament.previewImage.path)}">
  <div class="team-info">
    <div class="logo">
      <img [src]="team.logo.path" *ngIf="team.logo.path" [alt]="team.name">
      <div [class]="team.getEmptyLogoClass()" *ngIf="!team.logo.path"></div>
      <span class="icon-abs">
        <mtg-svg-icon icon="icons-hockey" *ngIf="team.sport.isHockey()"></mtg-svg-icon>
        <mtg-svg-icon icon="icons-basketball" *ngIf="team.sport.isBasketball()"></mtg-svg-icon>
        <mtg-svg-icon icon="icons-valleyball" *ngIf="team.sport.isVolleyball()"></mtg-svg-icon>
        <mtg-svg-icon icon="icons-football" *ngIf="team.sport.isFootball()"></mtg-svg-icon>
        <mtg-svg-icon icon="icons-handball" *ngIf="team.sport.isHandball()"></mtg-svg-icon>
        <mtg-svg-icon icon="icons-rugby" *ngIf="team.sport.isRugby()"></mtg-svg-icon>
      </span>
    </div>
    <div class="meta">
      <div class="name">{{ team.name }}</div>
      <div class="params">
        <div class="item">{{ team.city.name }}</div>
        <div class="item">{{ usersCount | pluralize: ['игрок', 'игрока', 'игроков'] }}</div>
      </div>
      <div class="tournament" *ngIf="tournamentTeam.division.id">
        <a class="btn-detail" [routerLink]="getTournamentRoute()" [queryParams]="getDivisionQueryParams()">{{ tournamentTeam.division.name }}</a>
      </div>
      <div class="tournament" *ngIf="!tournamentTeam.division.id && tournamentTeam.tournament.id">
        <a class="btn-detail" [routerLink]="getTournamentRoute()">{{ tournamentTeam.tournament.name }}</a>
      </div>
    </div>
  </div>
  <div class="statistic" *ngIf="teamStatistic">
    <div class="item award">
      <div class="count">{{ teamStatistic.wonGamesCount || 0 }}</div>
      <div class="name">Побед</div>
    </div>
    <div class="item">
      <div class="count">{{ teamStatistic.gamesCount || 0}}</div>
      <div class="name">Сыграно <br/>игр</div>
    </div>
    <div class="item" *ngIf="tournament.sport.isHockey()">
      <div class="count">{{ hockeyStatistic.teamScoreSum || 0 }}</div>
      <div class="name">Шайб <br/>за сезон</div>
    </div>
    <div class="item" *ngIf="tournament.sport.isFootball()">
      <div class="count">{{ footballStatistic.teamScoreSum || 0 }}</div>
      <div class="name">Голов <br/>за сезон</div>
    </div>
    <div class="item" *ngIf="tournament.sport.isHandball()">
      <div class="count">{{ handballStatistic.teamScoreSum || 0 }}</div>
      <div class="name">Голов <br/>за сезон</div>
    </div>
    <div class="item" *ngIf="tournament.sport.isBasketball()">
      <div class="count">{{ basketballStatistic.teamScoreSum || 0 }}</div>
      <div class="name">Очков <br/>за сезон</div>
    </div>
    <div class="item" *ngIf="tournament.sport.isVolleyball()">
      <div class="count">{{ volleyballStatistic.teamScoreSum || 0 }}</div>
      <div class="name">Выигранных партий <br/>за сезон</div>
    </div>
    <div class="item" *ngIf="tournament.sport.isRugby()">
      <div class="count">{{ rugbyStatistic.teamScoreSum || 0 }}</div>
      <div class="name">Очков <br />за сезон</div>
    </div>
  </div>
  <div class="application-link" *ngIf="actualTournamentTeam && actualTournamentTeam.tournament.sport.isHockey()">
    <mtg-button color="secondary" leadingIcon="icons-pdf-file" (click)="printApplication()">
      Заявка команды {{ actualTournamentTeam.tournament.season.name }}
    </mtg-button>
  </div>
</div>
